import React from 'react';

import styled from 'styled-components';

import IconArrowRight from 'components/icons/arrow-right';

import { IDimensions, IOrientation, ISize } from './types';

const defaultMobileDimensions: IDimensions = {
  width: 8,
  height: 14,
};
const defaultDesktopDimensions: IDimensions = {
  width: 12,
  height: 21,
};
export const defaultSize: ISize = {
  mobile: defaultMobileDimensions,
  desktop: defaultDesktopDimensions,
};

export const defaultOrientation: IOrientation = {
  initialAngleDeg: 0,
  finalAngleDeg: 90,
};

const maxDimension = (dimension: IDimensions) => Math.max(dimension.height, dimension.width);

interface IArrowContainer {
  size: ISize;
}
const ArrowContainer = styled.div<IArrowContainer>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 1;

  height: ${p => maxDimension(p.size.mobile)}px;
  width: ${p => maxDimension(p.size.mobile)}px;

  ${Styles.desktop`
    height: ${(p: IArrowContainer) => maxDimension(p.size.desktop)}px;
    width: ${(p: IArrowContainer) => maxDimension(p.size.desktop)}px;
  `}
`;

const calculateTransitionDuration = (orientation: IOrientation) => {
  const absDifferenceDeg = Math.abs(orientation.finalAngleDeg - orientation.initialAngleDeg);
  return Math.floor(absDifferenceDeg / 90) * 0.1;
};

interface IArrow {
  open: boolean;
  size: ISize;
  orientation: IOrientation;
}
const Arrow = styled(IconArrowRight)<IArrow>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${p => p.size.mobile.height}px;
  width: ${p => p.size.mobile.width}px;

  transition: ${p => `transform ${calculateTransitionDuration(p.orientation)}s ease-in-out`};
  transform: ${p =>
    p.open
      ? `rotate(${p.orientation.finalAngleDeg}deg)`
      : `rotate(${p.orientation.initialAngleDeg}deg)`};

  ${Styles.desktop`
    height: ${(p: IArrow) => p.size.desktop.height}px;
    width: ${(p: IArrow) => p.size.desktop.width}px;
  `}
`;

interface IDropdownArrow {
  open: boolean;
  disabled: boolean;
  size: ISize;
  orientation: IOrientation;
}

export const DropdownArrow: React.FC<IDropdownArrow> = ({ open, disabled, orientation, size }) => (
  <ArrowContainer size={size}>
    <Arrow
      open={open}
      size={size}
      orientation={orientation}
      fill={disabled ? Styles.color.grey.two : Styles.color.black}
    />
  </ArrowContainer>
);
